module.exports = __webpack_public_path__ + "img/no-profile.36ca16a1.png";